var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26,
    stroke: "#8EA1B1",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6402 28.3416L26.0971 35.6511C25.6173 36.1163 24.8393 36.1163 24.3597 35.6511C23.8801 35.1863 23.8801 34.4324 24.3597 33.9677L31.0342 27.4999L24.3599 21.0323C23.8803 20.5673 23.8803 19.8135 24.3599 19.3487C24.8396 18.8838 25.6175 18.8838 26.0973 19.3487L33.6404 26.6584C33.8802 26.8909 34 27.1953 34 27.4998C34 27.8046 33.88 28.1092 33.6402 28.3416Z",
    fill: "#8EA1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next_arrow.63a230d7.svg";
export { ForwardRef as ReactComponent };